import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import DatePickerComponent from '../../../../components/DatePicker';
import { ContentsContainerRoot } from '../../../../assets/styles/ContentsContainerRoot';
import { PulseLoader } from 'react-spinners';
import { LoadingModalBackground } from '../../../../assets/styles/Modal';

const Root = styled(ContentsContainerRoot)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 20rem;
  border-top: 1px solid var(--outline);

  .react-datepicker {
    outline: none !important;
    border: none;
    .react-datepicker__triangle {
      display: none;
    }
    .react-datepicker__triangle::before {
      border-bottom-color: var(--outline) !important;
    }

    .react-datepicker__month-container {
      max-width: 21rem;
      background-color: var(--board);

      > .react-datepicker__header--custom {
        background-color: var(--board);
      }
    }

    .react-datepicker__day--outside-month {
      cursor: default;
      visibility: hidden;
    }
  }
  .react-datepicker__header {
    border-bottom: none;
  }
  .custom-header {
    display: flex;
    align-items: center;
    justify-content: space-around;
    // range picker와 스타일 통일
    justify-content: space-between;
    padding: 0.25rem 1rem;

    .selectGroup {
      display: flex;
      gap: 0.75em;
      > .selectBox {
        position: relative;
        > span {
          position: absolute;
          right: 0.25rem;
          top: 50%;
          transform: translateY(-50%);
          user-select: none;
          pointer-events: none;
          font-size: 1.125rem;
          color: var(--text-disabled);
        }
      }
    }
    select {
      width: 30%;
      width: 5rem;
      /* &::after {
        content: '월';
        color: var(--zinc-300);
      } */
      cursor: pointer;
      option {
        text-align: left;
      }
    }
    > div:not(.selectGroup) {
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0.25rem;
      /* &:hover {
        background-color: var(--tonal);
      } */
      &:first-child,
      &:last-child {
        width: 1.5rem;
        height: 1.5rem;
        cursor: pointer;
        user-select: none;
        color: var(--text-primary);
        background-color: var(--tonal);
      }
    }

    /* > :nth-child(2) {
      padding: 0 1rem;
    } */
  }
  .react-datepicker__day {
    color: var(--text-primary);
  }
  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    color: var(--btn-text);
    background-color: var(--selected-primary);
    border-radius: 0.25rem;
    // range picker와 스타일 통일
    height: 1.625rem !important;
    width: 2.5rem !important;
    // margin: 0 auto;
    border-radius: 1rem;
    border-radius: 1rem;
    position: relative;
    &:hover {
      height: 2.25rem !important;
      width: 2.75rem !important;
      border-radius: 0.25rem;
    }
  }
  .react-datepicker__day-names {
    // height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0.4rem;
    > div {
      user-select: none;
      color: var(--text-disabled);
      width: 2.5rem;
      flex-grow: 1;
      // height: 1rem;
    }
  }
  .react-datepicker__month {
    margin: 0 0.8rem;
    text-align: center;
    padding-bottom: 0.75rem;
    .react-datepicker__week,
    .react-datepicker__day-names {
      height: 2.25rem;
      display: flex;
      justify-content: center;
      align-items: center;
      > div {
        width: 2.5rem;
        height: inherit;
        justify-content: center;
        align-items: center;
        display: flex;
        // range picker와 스타일 통일
        width: 2.75rem;
        height: 2.25rem;
        font-weight: 400;
        font-size: 0.75rem;
        padding-top: 0.125rem;
        &:hover {
          background-color: var(--selected-primary);
          color: white;
        }
      }
    }
  }

  .react-datepicker__day--selected {
    color: var(--zinc-100);
    border-radius: 1.042em;
    right: 2px;
  }

  .redDot {
    position: relative;
    top: -5px;
    right: 3px;

    &::after {
      content: '•';
      padding: 0 0.25rem;
      color: red;
      font-size: 1.2rem;
      position: absolute;
    }
  }
`;

interface Props {
  date: string;
  setDate: Dispatch<SetStateAction<string>>;
  records: Records | null;
  loading: boolean;
}

const RecordCalendar = ({ date, setDate, records, loading }: Props) => {
  return (
    <Root loading={loading}>
      <div className='datePickerWrapper'>
        <DatePickerComponent disabled={loading} startDate={date} setDate={setDate} popperPlacement='bottom' inline renderDayPointer={records !== null} records={records} />
      </div>
      {loading && (
        <LoadingModalBackground>
          <PulseLoader className='flex-center' color='rgb(0, 122, 255)' size='1rem' />
        </LoadingModalBackground>
      )}
    </Root>
  );
};

export default RecordCalendar;
